/**
 * Lightbox controller — tiny pub-sub so any component can open the global
 * fullscreen viewer without prop-drilling.
 *
 * Subscribed by <LightboxHost /> mounted in Layout.
 */
const listeners = new Set();
let _state = { open: false, images: [], index: 0 };

function setState(next) {
  _state = { ..._state, ...next };
  listeners.forEach((fn) => fn(_state));
}

export function openLightbox(images, index = 0) {
  setState({ open: true, images: images || [], index });
}

export function closeLightbox() {
  setState({ open: false });
}

export function subscribe(fn) {
  listeners.add(fn);
  fn(_state);
  return () => listeners.delete(fn);
}

export function getLightboxState() {
  return _state;
}
